import React from "react";

export const ProjectTech = ({ tech }) => {
  return <p className="usedTech">[{tech}]</p>;
};
